import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="app-footer-top">
        <div>
          <p className="app-footer-brand">LifeOS</p>
          <p className="app-footer-text">
            Your daily workspace for finance, planning, notes, and files.
          </p>
        </div>

        <div className="app-footer-actions">
          <a className="btn btn-primary" href="mailto:support@lifeos.app">
            Email Support
          </a>
          <a className="btn" href="tel:+18005550123">
            Call Support
          </a>
        </div>
      </div>

      <div className="app-footer-bottom">
        <div className="app-footer-links">
          <Link to="/today">Today</Link>
          <Link to="/search">Search</Link>
          <Link to="/finance">Finance</Link>
          <Link to="/planner">Planner</Link>
          <Link to="/calendar">Calendar</Link>
          <Link to="/notes">Notes</Link>
          <Link to="/files">Files</Link>
        </div>

        <p className="app-footer-copy">© {year} LifeOS. All rights reserved.</p>
      </div>
    </footer>
  );
}
